// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w8jyO","top":"styles_top__3spuB","left":"styles_left__2GRZQ","description":"styles_description__3SR3W"};